module.exports = __webpack_public_path__ + "img/5_2022TerryFoxRun_WomenPerformanceTShirt.82ec30b4.png";